import ReviewsAndRatings from './reviews-and-ratings.es6.js';
import AssistantButton from './assistant-button.es6.js';
import {
  MarkerClusterer,
  SuperClusterAlgorithm,
} from '@googlemaps/markerclusterer';
import ApiUtils from "./api-utils.es6.js";

export default class FindProvidersMap {
  constructor(providers = []) {
    this.providers = providers;
    this.provsWithPrimaryLocations = this.providers.filter(
      provider => provider.primary_location != null,
    );
    this.providerResultsWrapper = document.querySelector(
      '.provider-results-grid--wrapper',
    );
    this.dumpedImages = this.providerResultsWrapper.querySelector(
      '.dumped-images',
    );
    this.dumpedLabels = this.providerResultsWrapper.querySelector(
      '.dumped-labels',
    );
    this.viewProfileLabel = this.dumpedLabels.querySelector(
      '.field--name-field-view-profile-label',
    ).textContent;
    this.ofLabel = this.dumpedLabels.querySelector(
      '.field--name-field-of-label',
    ).textContent;
    this.clusterProviders = [];
    this.activeProviderPinUrl = this.dumpedImages
      .querySelector('.field--name-field-media-image')
      .querySelector('img').src;
    this.inactiveProviderPinUrl = this.dumpedImages
      .querySelector('.field--name-field-media-image-2')
      .querySelector('img').src;
    this.activeClusterPinUrl = this.dumpedImages
      .querySelector('.field--name-field-media-image-3')
      .querySelector('img').src;
    this.inactiveClusterPinUrl = this.dumpedImages
      .querySelector('.field--name-field-media-image-4')
      .querySelector('img').src;
    this.map = null;
    this.markers = [];
    this.infoWindow = null;
    this.infoWindowDiv = null;
    this.infoCloseButton = null;
    this.glide = null;
    this.setUpMap();
    this.setListeners();
    AssistantButton.hideLauncher();
  }

  setListeners() {
    document.addEventListener('mousedown', event => {
      this.detectIfClickedOutsideOfDiv(event.target);
    });
  }

  detectIfClickedOutsideOfDiv(target) {
    if (
      this.infoWindowDiv &&
      target !== this.infoCloseButton &&
      target !== this.infoWindow &&
      !this.infoWindowDiv.contains(target) &&
      !this.infoWindowDiv.contains(target)
    ) {
      this.closeInfoWindow();
    }
  }

  async setUpMap() {
    const loader = new google.maps.plugins.loader.Loader({
      apiKey: 'AIzaSyB_-JON1px4G3i047DSm_A3YX6DJzGlXpY',
      libraries: ['places'],
    });
    loader.load().then(google => {
      this.map = new google.maps.Map(
        document.getElementById('find-providers-locations-map'),
        {
          zoom: 11,
        },
      );

      this.setLocationMarkers();

      if (this.provsWithPrimaryLocations.length > 0 &&
        this.provsWithPrimaryLocations[0].primary_location.field_geolocation) {
        this.map.setCenter({
          lat: FindProvidersMap.getLatNumber(
            this.provsWithPrimaryLocations[0].primary_location
              .field_geolocation,
          ),
          lng: FindProvidersMap.getLonNumber(
            this.provsWithPrimaryLocations[0].primary_location
              .field_geolocation,
          ),
        });
      }
    });
  }

  createMarker(provider) {
    const latLonObj = {
      lat: FindProvidersMap.getLatNumber(
        provider.primary_location.field_geolocation,
      ),
      lng: FindProvidersMap.getLonNumber(
        provider.primary_location.field_geolocation,
      ),
    };
    const marker = new google.maps.Marker({
      map: this.map,
      icon: {
        url: this.inactiveProviderPinUrl,
        scaledSize: new google.maps.Size(24, 24),
      },
      position: latLonObj,
      // eslint-disable-next-line new-cap
      anchorPoint: google.maps.Size(200, 200),
      animation: google.maps.Animation.DROP,
    });
    if (this.providers.length > 0) {
      marker.provider = provider;
      marker.addListener('click', () => {
        this.onMarkerClick(marker, provider);
      });
    }
    return marker;
  }

  setAllMarkersInactive() {
    this.markerClusterer.clusters.forEach(cluster => {
      cluster.marker.setIcon({
        url: this.inactiveClusterPinUrl,
        scaledSize: new google.maps.Size(54, 28),
      });
    });

    this.markers.forEach(marker => {
      marker.setIcon({
        url: this.inactiveProviderPinUrl,
        scaledSize: new google.maps.Size(24, 24),
      });
    });
  }

  closeInfoWindow() {
    if (this.infoWindow) {
      this.infoWindow.close();
    }
  }

  static getHrefFromLinkString(resultNameLinkString) {
    const parser = new DOMParser();
    const linkElement = parser.parseFromString(
      resultNameLinkString,
      'text/html',
    );
    return linkElement.body.firstElementChild.href;
  }

  buildViewProviderLink(resultNameLinkString) {
    return `<a class="provider-details-link" href="${FindProvidersMap.getHrefFromLinkString(
      resultNameLinkString,
    )}">${this.viewProfileLabel}</a>`;
  }

  static getProviderImage(data) {
    let imageUrl = '';
    if (data.hero_banner_hero_image) {
      imageUrl = data.hero_banner_hero_image;
    } else {
      imageUrl = '/themes/custom/luminis/images/provider_placeholder_image.svg';
    }
    return imageUrl;
  }

  static getProviderOverallRatings(npi) {
    const reviewsAndRatings = new ReviewsAndRatings(npi);
    reviewsAndRatings.starsOnlyWidget(jQuery);
  }

  buildProviderContentString(provider) {
    return (
      `<div class="marker-info-window--wrapper provider glide__slide">` +
      `<div class="provider-details--wrapper">` +
      `${provider.field_hero_banner_text}` +
      `<p class="specialty">${ApiUtils.getProviderSpecialtiesArray(
        provider,
      )}</p>` +
      `<span id='star-ratings-${provider.field_provider_npi_number}' class='provider-info__ratings provider-star-ratings'>` +
      `<div id='overall-${provider.field_provider_npi_number}' class='overall-star-rating'></div>` +
      `<div id='no-star-${provider.field_provider_npi_number}' class='no-star-ratings'>` +
      `<a class="hidden" href='${provider.field_no_rating_link.replace(
        'entity:',
        `${window.location.origin}/`,
      )}' target="_blank">` +
      `${provider.field_no_rating_text}` +
      `</a>` +
      `</div>` +
      `</span>` +
      `${this.buildViewProviderLink(provider.title)}` +
      `</div>` +
      `<img src="${FindProvidersMap.getProviderImage(provider)}"/>` +
      `</div>`
    );
  }

  static buildProviderCarouselContentString() {
    return (
      `<div class="glide">` +
      `<div class="glide__track" data-glide-el="track">` +
      `<ul class="glide__slides">` +
      `</ul>` +
      `</div>` +
      `<div class="glide__arrows" data-glide-el="controls">` +
      `<button class="glide__arrow glide__arrow--left" data-glide-dir="<"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"/></svg></button>` +
      `<p class="glide-count"></p>` +
      `<button class="glide__arrow glide__arrow--right" data-glide-dir=">"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"/></svg></button>` +
      `</div>` +
      `</div>`
    );
  }

  attachSlidesToCarousel(providers) {
    const parser = new DOMParser();
    const slides = document.querySelector('.glide__slides');
    providers.forEach(provider => {
      slides.append(
        parser.parseFromString(
          this.buildProviderContentString(provider),
          'text/html',
        ).body.firstElementChild,
      );
    });
  }

  buildContentString(data) {
    if (this.providers.length > 0) {
      if (data.type) {
        return this.buildProviderContentString(data);
      }
      return FindProvidersMap.buildProviderCarouselContentString();
    }
  }

  setUpGlide() {
    this.glide = new Glide('.glide');
    this.glide.update({
      type: 'carousel',
      startAt: 0,
      keyboard: true,
      animationDuration: 250,
      gap: 0,
      focusAt: 'center',
      perView: 1,
    });
    this.glide.mount();
    this.glide.on('move.after', () => this.updateGlideCount());
  }

  updateGlideCount() {
    const zeroIndexEqualizer = 1;
    document.querySelector('.glide-count').textContent = `${this.glide.index +
      zeroIndexEqualizer} ${this.ofLabel} ${this.clusterProviders.length}`;
  }

  createInfoWindow(data, marker) {
    const contentString = this.buildContentString(data);
    this.infoWindow = new google.maps.InfoWindow({
      content: contentString,
    });
    this.infoWindow.open({
      anchor: marker,
      map: this.map,
      shouldFocus: false,
    });
    this.infoWindow.addListener('domready', () => {
      this.infoWindowDiv = document.querySelector('.gm-style-iw.gm-style-iw-c');
      this.infoCloseButton = this.infoWindowDiv.querySelector(
        '.gm-ui-hover-effect',
      );
      if (this.providers.length > 0) {
        if (!data.type) {
          this.attachSlidesToCarousel(data);
          this.setUpGlide();
          this.updateGlideCount();
          data.forEach(dataChild => {
            FindProvidersMap.getProviderOverallRatings(
              dataChild.field_provider_npi_number,
            );
          });
        } else {
          FindProvidersMap.getProviderOverallRatings(
            data.field_provider_npi_number,
          );
        }
      }
      const infoWindowHeight = this.infoWindowDiv.clientHeight;
      this.infoWindow.setOptions({
        pixelOffset: new google.maps.Size(0, infoWindowHeight + 70),
      });
    });
  }

  onMarkerClick(marker, data) {
    this.closeInfoWindow();
    this.setAllMarkersInactive();
    marker.setIcon({
      url: this.activeProviderPinUrl,
      scaledSize: new google.maps.Size(24, 24),
    });
    this.map.setCenter(marker.getPosition());
    this.createInfoWindow(data, marker);
  }

  static getMarkerProvs(markers) {
    const markerProvs = [];
    markers.forEach(marker => {
      markerProvs.push(marker.provider);
    });
    return markerProvs;
  }

  onClusterClick(e, cluster) {
    this.closeInfoWindow();
    this.setAllMarkersInactive();
    this.map.setCenter(cluster.marker.getPosition());
    this.clusterProviders = FindProvidersMap.getMarkerProvs(cluster.markers);
    this.createInfoWindow(this.clusterProviders, cluster.marker);
    cluster.marker.setIcon({
      url: this.activeClusterPinUrl,
      scaledSize: new google.maps.Size(54, 28),
    });
  }

  async setLocationMarkers() {
    const renderer = {
      render: ({ count, position }) =>
        new google.maps.Marker({
          label: {
            text: String(`\xa0\xa0\xa0\xa0${count}`),
            color: 'white',
            fontSize: '14px',
          },
          position,
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          icon: {
            url: this.inactiveClusterPinUrl,
            scaledSize: new google.maps.Size(54, 28),
          },
        }),
    };

    this.markers = this.provsWithPrimaryLocations.map(provider => this.createMarker(provider));

    this.markerClusterer = new MarkerClusterer({
      map: this.map,
      markers: this.markers,
      algorithm: new SuperClusterAlgorithm({
        maxZoom: 22,
      }),
      renderer,
      onClusterClick: (e, cluster) => this.onClusterClick(e, cluster),
    });
  }

  static getLatNumber(latLonString) {
    if (latLonString) {
      const latString = latLonString.split(', ')[0];
      return parseFloat(latString);
    }
    return 0;
  }

  static getLonNumber(latLonString) {
    if (latLonString) {
      const lonString = latLonString.split(', ')[1];
      return parseFloat(lonString);
    }
    return 0;
  }
}
